import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=e6d1990e&"
import script from "./unauthorized.vue?vue&type=script&lang=js&"
export * from "./unauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports